import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import RemarksDialog from '../../../invoices/pendingInvoices/common/RemarksDialog';
import FormDialog from '../../../invoices/pendingInvoices/common/FormDialog';

function stableSort(array) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
    const { classes, headCells, action } = props;

    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        className={classes.TableHeadCss}
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                    >
                        {headCell.label}
                    </TableCell>
                ))}
                {action && (
                    <TableCell className={classes.TableHeadCss} align="center">
                        Action
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },

    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    TableHeadCss: {
        fontWeight: '700',
        fontFamily: 'Rubik',
        fontSize: '14px',
        color: '#31333F',
        backgroundColor: '#dcdcdc',
    },
    tableRow: {
        height: '50px',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    // tableContainerMin: {
    //     maxHeight: '800px',
    // },
    fontDesign: {
        fontFamily: 'Rubik',
        color: '#808080',
    },
    '@global': {
        '*::-webkit-scrollbar': {
            width: '0.4em',
        },
        '*::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgb(0 0 0 / 65%)',
        },
    },
}));

export default function DataTable({
    rows,
    headCells,
    pageName,
    getLevel,
    saveRow,
    editPage,
    handleDelete,
    action,
    axiosConfig,
    tennantName,
    id,
}) {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);

    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    // const handleRowDelete = () => {
    // };
    // const handleSave = () => {
    // };

    const handleClick = (_event, name) => {};

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    // const openInTab = (url) => {
    //   window.open(url, '_blank');
    // };
    const rowData = (row) => {
        return headCells.map((col) => {
            //console.log('row........', row);
            if (col.isConcat && row[col.id]) {
                const subdata = row[col.id];
                const mergedData = col.concatElem.map((concatdata) => {
                    return concatdata.split('.').reduce((acc, item) => {
                        //console.log(acc,item, "Acc Item");
                        if (Object.prototype.hasOwnProperty.call(acc, item)) {
                            //console.log(acc[item],"value in table");
                            return acc[item];
                        }
                        return '';
                    }, subdata);
                });
                return (
                    <TableCell align="left" key={col.id}>
                        {mergedData.join(' ')}
                    </TableCell>
                );
            }
            return (
                <TableCell align="left" key={col.id}>
                    {row[col.id]}
                </TableCell>
            );
        });
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <TableContainer className={classes.tableContainerMin}>
                    <Table className={classes.table} size="medium" stickyHeader aria-label="sticky table">
                        <EnhancedTableHead classes={classes} headCells={headCells} action={action} />
                        <TableBody style={{ fontFamily: 'Rubik', color: '#808080' }}>
                            {stableSort(rows)
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    //  const isItemSelected = isSelected(row[headCells[0].id]);
                                    // const labelId = `enhanced-table-checkbox-${index}`;
                                    const rowDataShow = rowData(row);
                                    let slno = 1;
                                    if (page > 0) {
                                        slno = page * rowsPerPage + 1;
                                    }
                                    slno += index;
                                    return (
                                        <TableRow
                                            hover
                                            onClick={(event) => handleClick(event, row)}
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={slno}
                                            className={classes.tableRow}
                                        >
                                            <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }}>{slno}</TableCell>
                                            {rowDataShow}
                                            {action && (
                                                <TableCell style={{ fontFamily: 'Rubik', color: '#808080' }} align="center">
                                                    <div>
                                                        {/* <FormDialog
                                                            row={row}
                                                            saveRow={saveRow}
                                                            pageName={pageName}
                                                            show="editIcon"
                                                            rows={rows}
                                                        /> */}
                                                        <FormDialog row={row} axiosConfig={axiosConfig} tennantName={tennantName} id={id} />
                                                        <RemarksDialog
                                                            row={row}
                                                            deleteRow={handleDelete}

                                                            // editpageName={editPage}
                                                        />
                                                    </div>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                    <TableCell style={{ fontFamily: 'Rubik', color: 'red' }} colSpan={10} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    getLevel={getLevel}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    );
}
